import { render, staticRenderFns } from "./CustomerDetail-notes.vue?vue&type=template&id=38639ed0&scoped=true"
import script from "./CustomerDetail-notes.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-notes.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-notes.vue?vue&type=style&index=0&id=38639ed0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38639ed0",
  null
  
)

export default component.exports